import * as React from 'react';
import {  FormCheckbox} from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';
import { Checkbox } from '@progress/kendo-react-inputs';

const DeclarationChkbox = (props) => {

    const [checkedValue, setCheckedValue] = React.useState(props.checkedValue);
 
    const handleCheckedChange = async (event) => {
 
        setCheckedValue(event.value);
        await props.onCheckedChange(event.value,props);
    }

    return(
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
 
        <div className="dclare-chk-box">
            <Field id={props.id}
                    name={props.id}
                    component={FormCheckbox}
                    checked={checkedValue}
                    onChange={handleCheckedChange}>
            </Field>
         </div>
         <div className={'k-form-field dclare-chk-lbl'}  >
         <span>{props.lblname}</span>
         </div>
        </div>
    )
}

export default DeclarationChkbox;